import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { authService } from "../services/auth";

const Navbar = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    if (location.pathname !== "/") return;

    const sections = ["home", "features", "clients", "about", "contact"];

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleSections = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visibleSections.length > 0) {
          setActiveSection(visibleSections[0].target.id);
        }
      },
      {
        rootMargin: "-40% 0px -60% 0px", // 🔥 KEY LINE
        threshold: 0,
      }
    );

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [location.pathname]);



  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoggedIn, setIsLoggedIn] = React.useState(
    authService.isAuthenticated()
  );

  React.useEffect(() => {
    setIsLoggedIn(authService.isAuthenticated());
    setIsOpen(false); // Close menu on route change
  }, [location.pathname]);

  const hiddenRoutes = [
    "/login",
    "/dashboard",
    "/dashboard/list",
    "/attendance",
    "/manage-students",
    "/manage-staffs",
    "/invoice-report",
    "/admin-config",
    "/register"
  ];

  const shouldHideNavbar = hiddenRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  if (shouldHideNavbar) return null;

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    authService.logout();
    setIsLoggedIn(false);
    window.location.href = "/";
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <img
            src="/assets/images/feezaap-logo.png"
            alt="FeeZaap Logo"
            className="logo-img"
          />
          <span className="logo-text">FeeZaap</span>
        </div>

        <div className={`nav-menu ${isOpen ? "active" : ""}`}>
          {/* Home route */}
          <Link
            to="/"
            className={`nav-link ${activeSection === "home" ? "active" : ""}`}
          >
            Home
          </Link>

          <Link
            to="/#features"
            className={`nav-link ${activeSection === "features" ? "active" : ""}`}
          >
            Features
          </Link>

          <Link
            to="/#clients"
            className={`nav-link ${activeSection === "clients" ? "active" : ""}`}
          >
            Clients
          </Link>

          <Link
            to="/#about"
            className={`nav-link ${activeSection === "about" ? "active" : ""}`}
          >
            About
          </Link>

          <Link
            to="/#contact"
            className={`nav-link ${activeSection === "contact" ? "active" : ""}`}
          >
            Contact
          </Link>



          {/* Normal routes */}
          <NavLink
            to="/login"
            className={({ isActive }) =>
              `nav-link ${isActive ? "active" : ""}`
            }
          >
            Login
          </NavLink>



          {isLoggedIn && (
            <button onClick={handleLogout} className="btn btn-secondary">
              Logout
            </button>
          )}
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
